import SvgIcon from './SvgIcon';

const TrashcanIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 12 15">
    <g
      id="Current"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      opacity="0.600000024">
      <g
        id="1.03-Filtered-alterts"
        transform="translate(-1389.000000, -287.000000)"
        fill="#969BA1"
        fillRule="nonzero">
        <g id="Segments" transform="translate(801.000000, 0.000000)">
          <g id="collection" transform="translate(40.000000, 192.000000)">
            <g id="list-item" transform="translate(0.000000, 85.000000)">
              <g id="right-actions" transform="translate(369.000000, 8.000000)">
                <g id="Trash-Icon" transform="translate(179.000000, 2.000000)">
                  <path
                    d="M1.71747692,13.5822222 C1.80646154,14.345 2.50523077,14.9707407 3.27230769,14.9707407 L8.74227692,14.9707407 C9.50972308,14.9707407 10.2090462,14.345 10.2972923,13.5822222 L11.4371077,3.75481481 L0.578953846,3.75481481 L1.71747692,13.5822222 Z M8.54012308,5.01759259 C8.5632,4.75611111 8.79027692,4.56407407 9.04836923,4.585 C9.30812308,4.60740741 9.50030769,4.8362963 9.47963077,5.09722222 L8.81132308,12.995 C8.78990769,13.2542593 8.56024615,13.4472222 8.30363077,13.425 C8.04350769,13.4038889 7.85150769,13.1753704 7.87292308,12.9153704 L8.54012308,5.01759259 Z M5.53716923,5.0562963 C5.53716923,4.79555556 5.74781538,4.58296296 6.00646154,4.58296296 C6.26750769,4.58296296 6.47778462,4.79537037 6.47778462,5.0562963 L6.47778462,12.955 C6.47778462,13.2157407 6.26750769,13.4266667 6.00646154,13.4266667 C5.74781538,13.4266667 5.53716923,13.2157407 5.53716923,12.955 L5.53716923,5.0562963 Z M2.9664,4.585 C3.22504615,4.56407407 3.45249231,4.75611111 3.47464615,5.01759259 L4.14147692,12.9153704 C4.16455385,13.1753704 3.97107692,13.4038889 3.71353846,13.425 C3.45341538,13.4472222 3.22523077,13.2542593 3.204,12.995 L2.53569231,5.09722222 C2.51575385,4.8362963 2.7072,4.60740741 2.9664,4.585 Z"
                    id="Shape"
                  />
                  <path
                    d="M7.78043077,0.924074074 C7.79150769,0.873518519 7.79907692,0.821296296 7.79907692,0.765185185 L7.79907692,0.726481481 C7.79889231,0.326666667 7.47267692,0 7.07427692,0 L5.44393846,0 C5.04590769,0 4.71895385,0.326666667 4.71895385,0.726296296 L4.71895385,0.765 C4.71895385,0.821111111 4.72744615,0.873333333 4.73815385,0.923888889 L7.78043077,0.923888889 L7.78043077,0.924074074 Z"
                    id="Shape"
                  />
                  <path
                    d="M10.8550154,1.57314815 L1.15975385,1.57314815 C0.495138462,1.58314815 0.0177230769,1.98203704 0.0149538462,2.59925926 L0.0149538462,3.03462963 L12,3.03462963 L12,2.59925926 C11.9961231,1.98203704 11.5185231,1.58314815 10.8550154,1.57314815 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

TrashcanIcon.defaultProps = {
  width: 12,
  height: 15,
};

TrashcanIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

export default TrashcanIcon;
